module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('div', {
    staticClass: "banner"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('general.school')))])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('skischool.pick-school-title')))]), _vm._v(" "), _c('p', [_vm._v("\n          " + _vm._s(_vm.$t('skischool.description')) + "\n          "), (_vm.SITE_CONFIG.site === 'vallasen') ? _c('span', [_vm._v(_vm._s(_vm.$t('skischool.vallasen-gathering')))]) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.site === 'ulricehamn') ? _c('span', [_vm._v(_vm._s(_vm.$t('skischool.ulricehamn-gathering')))]) : _vm._e()]), _vm._v(" "), (_vm.SITE_CONFIG.skischool.map) ? _c('OutlineButton', {
    attrs: {
      "label": _vm.$t('skischool.show-gathering'),
      "icon": "map",
      "iconscale": 1.7
    },
    on: {
      "clicked": _vm.openLocationMap
    }
  }) : _vm._e()], 1), _vm._v(" "), _vm._l((_vm.schools), function(ref) {
    var name = ref.name;
    var list = ref.list;
    var bookable = ref.bookable;
    var image = ref.image;
    var type = ref.type;
    var show = ref.show;

    return (show) ? _c('div', {
      staticClass: "items-list"
    }, [_c('div', {
      staticClass: "item",
      on: {
        "click": function($event) {
          return _vm.openBooking(type)
        }
      }
    }, [_c('div', {
      staticClass: "item-image",
      style: ('background-image:url(https://static.booking.branasgruppen.se/static/img/Skidskola/' + image + ')')
    }), _vm._v(" "), _c('div', {
      staticClass: "item-body"
    }, [_c('div', {}, [_c('h2', [_vm._v(_vm._s(name))]), _vm._v(" "), _c('ul', _vm._l((list), function(name) {
      return _c('li', [_vm._v(_vm._s(name))])
    }), 0)]), _vm._v(" "), _c('div', {
      staticClass: "buttons min-tablet"
    }, [_c('div', {
      staticClass: "spacer"
    }), _vm._v(" "), (bookable) ? _c('button', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.$t('general.cta.book-thing', {
      thing: ''
    })) + " " + _vm._s(name))]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "buttons max-mobile"
    }, [_c('div', {
      staticClass: "spacer"
    }), _vm._v(" "), (bookable) ? _c('button', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.$t('general.cta.book-thing', {
      thing: ''
    })) + " " + _vm._s(name))]) : _vm._e()])])]) : _vm._e()
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "info-content",
    domProps: {
      "innerHTML": _vm._s(_vm.pageContent)
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ac00dce0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/SkiSchool/SkiSchoolPage.vue
// module id = 994
// module chunks = 0